var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaferGamblingFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.649 3.132l-7 2.625A1 1 0 004 6.693v3.657a10.976 10.976 0 006.754 10.13l.964.402c.18.076.383.076.564 0l.964-.401A10.976 10.976 0 0020 10.35V6.693a1 1 0 00-.649-.936l-7-2.625a1 1 0 00-.702 0zm4.39 6.39a.75.75 0 00-1.078-1.044l-4.307 4.444-1.615-1.666A.75.75 0 107.96 12.3l2.154 2.222.539.556.538-.556 4.847-5z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.913 5.795l8-2.963a.25.25 0 01.174 0l8 2.963a.25.25 0 01.163.234v4.12a11.411 11.411 0 01-7.07 10.554l-1.152.474a.072.072 0 01-.056 0l-1.153-.474A11.413 11.413 0 013.75 10.15V6.03a.25.25 0 01.163-.234l-.26-.703.26.703z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })));
}
SvgSaferGamblingFilled.displayName = 'SaferGamblingFilled';
export default SvgSaferGamblingFilled;